import tableMixin from '../../../components/table/table-mixin.js'
import year from '../../../utils/year'
import url from "../../../utils/url";
import FormValidator from '../../../components/form/form-validator.js'

export default {
  mixins: [tableMixin],
  data () {
    return {
      tabView: 'tab1',
      filterModel: {
        _from_year: '',
        _to_year: '',
        operator_id: '',
        _operatorName: ''
      }
    }
  },
  created () {
    this.formValidator = new FormValidator(this)
    this.yearDiapasonChecker()
  },
  watch: {
    'fromYears': 'yearDiapasonChecker',
    'toYears': 'yearDiapasonChecker'
  },
  computed: {
    itemsCropped () {
      let itemsData = []
      let fY = this.$route.query['filter[_from_year]']
      let tY = this.$route.query['filter[_to_year]']
      if (this.items && this.items.data) {
        this.items.data.forEach(v => {
          if (fY && tY) {
            if (v.year >= fY && v.year <= tY) {
              itemsData.push(v)
            }
          }
        })
      }
      return {
        data: itemsData,
        _meta: this.items._meta
      }
    },
    filterFormName () {
      return 'filter'
    },
    fromYears () {
      if (this.tariffExist) {
        return this.getYears(this.items.data)
      }
      return this.defaultYears
    },
    toYears () {
      if (this.tariffExist) {
        return this.getYears(this.items.data)
      }
      return this.defaultYears
    },
    defaultYears () {
      let years = year.getSpecifiedYearsOptions(2018, 2030)
      years.reverse()
      return years
    },
    operatorSelected () {
      return this.$route.query['filter[operator_id]']
    },
    tariffExist () {
      if (this.items && this.items.data && this.items.data.length > 0) {
        return true
      }
      return false
    }
  },
  methods: {
    yearDiapasonChecker () {
      if (this.filterModel._from_year && this.fromYears) {
        let found = this.fromYears.findIndex(v => v.id == this.filterModel._from_year)
        if (found === -1) {
          this.filterModel._from_year = this.fromYears[0].id
        }
      }
      if (this.filterModel._to_year && this.toYears) {
        let found = this.toYears.findIndex(v => v.id == this.filterModel._to_year)
        if (found === -1) {
          this.filterModel._to_year = this.toYears[this.toYears.length - 1].id
        }
      }
    },
    getYears (itemsArr = []) {
      let years = []
      itemsArr.forEach(v => {
        years.push({
          id: v.year, name: v.year
        })
      })
      return years
    },
    openForCalc ({row}) {
      let name = row.yearOrder > 1
        ? 'calculation.regionalTariffs.nextUpdate'
        : 'calculation.regionalTariffs.firstUpdate'
      let prevRoute = url.getRoute(this.$route, true)
      this.$router.push({
        name,
        params: {id: row.id},
        query: {
          'filter[operator_id]': row.operator_id,
          prevRoute: prevRoute
        }
      })
    },
    validateFilter () {
      let {hasError} = this.formValidator.validate(this)
      if (!hasError) {
        if (this.filterModel.from_year > this.filterModel.to_year) {
          this.formValidator.handleServerErrors({
            data: {
              errors: {
                from_year: 'От не может быть больше до'
              }
            }
          })
          return false
        }
        return true
      }
      return false
    },
    createTariff () {
      if (this.validateFilter()) {
        this.$bar.start()
        this.batchCreateTariff().then(r => {
          this.showOnSuccess()
          this.reFetchData()
        }).catch(e => {
          this.showOnError(e)
          this.reFetchData()
        })
      }
    },
    removeTariff () {
      this.confirmBox(
        'Будут удалены все записи',
        'Очистить тариф для данного оператора?',
        'Удалить все'
      ).then(() => {
        this.$bar.start()
        this.batchRemoveTariff().then(r => {
          this.showOnSuccess()
          this.reFetchData()
        }).catch(e => {
          this.showOnError(e)
          this.reFetchData()
        })
      })
    },
    batchRemoveTariff: async function () {
      for (let i = 0; i < this.items.data.length; i++) {
        await this.$store.dispatch('deleteModel', {
          url: this.getDeleteUrl(this.items.data[i].id),
          endpoint: this.getEndpoint(this.$route)
        })
      }
      return Promise.resolve(1)
    },
    batchCreateTariff: async function () {
      let start = +this.filterModel._from_year
      let end = +this.filterModel._to_year
      let yOrder = 0
      for (let i = start; i <= end; i++) {
        yOrder++
        await this.$store.dispatch('createModel', {
          url: this.getCreateTariffEndpoint(),
          data: {
            operator_id: +this.filterModel.operator_id,
            year: i,
            yearOrder: yOrder
          }
        })
      }
      return Promise.resolve(1)
    },
    selectItem ($event) {
      if ($event && $event.id) {
        let copy = JSON.parse(JSON.stringify($event))
        this.filterModel.operator_id = copy.id
        this.filterModel._operatorName = this.$options.filters.stripHtml(
          copy.name
        )
      } else {
        this.filterModel.operator_id = ''
        this.filterModel._operatorName = ''
      }
      this.onFilterChange()
    },
    transformSuggestions (ctx, data) {
      return data.data
    },
    onFilterChange () {
      if (this.validateFilter()) {
        this.applyFilter()
      }
    }
  },
  asyncData ({store, route, fromRoute, methods}) {
    // if open modal
    if (fromRoute) {
      let jsonRoute = url.getRoute(fromRoute, true)

      if (route.query.prevRoute && route.query.prevRoute === jsonRoute) {
        return Promise.resolve(1)
      }
    }

    return store.dispatch('updateUrlEndpoint', {endpoint: methods.getEndpoint(route, fromRoute)})
  }
}
